const { banks } = require('@transfeeradev/api-enums');

class TransferTEDService {
  static formatDigit(bankCode, digit) {
    if (banks.BANCO_DO_BRASIL.code === bankCode) {
      const digitString = String(digit).toLowerCase();
      if (digitString === 'x') {
        return '0';
      }
    }
    return digit;
  }
}

module.exports = TransferTEDService;
